import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    // Global targets (single-rate form)
    "classroomSelect", "subjectSelect", "usedCombinations", "combinationError", "submitButton"
  ]

  connect() {
    // Initial validation on connect (useful when the page re-renders with values)
    this.checkAvailableCombinations()
  }

  loadEmployeeData(event) {
    const employeeProfileId = event?.target?.value
    if (!employeeProfileId) {
      const container = document.getElementById('hourly_rates_container')
      if (container) container.innerHTML = ''
      return
    }

    const url = `/schools/payrolls/hourly_rates/load_employee_data?employee_profile_id=${employeeProfileId}`
    fetch(url, { headers: { 'Accept': 'text/vnd.turbo-stream.html', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.text())
      .then(html => { Turbo.renderStreamMessage(html) })
      .catch(err => console.error('Erreur lors du chargement des données:', err))
  }

  // Action: change->hourly-rates#checkAvailableCombinations
  checkAvailableCombinations(event) {
    // Determine the scope: inside a row (multi-form) or global (single form)
    const scope = event?.target?.closest('.nested-fields') || this.element

    const classroomSelect = scope.querySelector('[data-hourly-rates-target="classroomSelect"]') || this.classroomSelectTargetNullable
    const subjectSelect = scope.querySelector('[data-hourly-rates-target="subjectSelect"]') || this.subjectSelectTargetNullable
    const errorBox = scope.querySelector('[data-hourly-rates-target="combinationError"]') || this.combinationErrorTargetNullable

    const classroomId = classroomSelect ? parseInt(classroomSelect.value || "", 10) : NaN
    const subjectId = subjectSelect ? parseInt(subjectSelect.value || "", 10) : NaN

    // If one is missing, just clear error and enable submit
    if (!Number.isFinite(classroomId) || !Number.isFinite(subjectId)) {
      this.#hideError(errorBox)
      this.#toggleSubmit(true)
      return
    }

    const usedPairs = this.#collectUsedPairs()
    const isDuplicate = usedPairs.has(`${classroomId}:${subjectId}`)

    if (isDuplicate) {
      this.#showError(errorBox)
      this.#toggleSubmit(false)
    } else {
      this.#hideError(errorBox)
      this.#toggleSubmit(true)
    }
  }

  // PRIVATE
  #collectUsedPairs() {
    const set = new Set()
    // Gather from all usedCombinations targets on the page (supports turbo updates)
    const containers = this.usedCombinationsTargets || []
    containers.forEach(c => {
      c.querySelectorAll('input[data-classroom-id][data-subject-id]').forEach(i => {
        const cId = i.getAttribute('data-classroom-id')
        const sId = i.getAttribute('data-subject-id')
        if (cId && sId) set.add(`${cId}:${sId}`)
      })
    })
    return set
  }

  #toggleSubmit(enabled) {
    // Handle both single and multiple submit buttons
    const buttons = this.submitButtonTargets && this.submitButtonTargets.length > 0 ? this.submitButtonTargets : (this.submitButtonTargetNullable ? [this.submitButtonTargetNullable] : [])
    buttons.forEach(b => { b.disabled = !enabled })
  }

  #showError(el) { if (el) { el.classList.remove('hidden') } }
  #hideError(el) { if (el) { el.classList.add('hidden') } }

  // Helpers to avoid exceptions when a specific target is not present in the current layout
  get classroomSelectTargetNullable() { try { return this.hasClassroomSelectTarget ? this.classroomSelectTarget : null } catch { return null } }
  get subjectSelectTargetNullable() { try { return this.hasSubjectSelectTarget ? this.subjectSelectTarget : null } catch { return null } }
  get combinationErrorTargetNullable() { try { return this.hasCombinationErrorTarget ? this.combinationErrorTarget : null } catch { return null } }
  get submitButtonTargetNullable() { try { return this.hasSubmitButtonTarget ? this.submitButtonTarget : null } catch { return null } }
}
